import type { FunctionalComponent } from 'preact';

interface Props {
  value: number;
  max: number;
  onChange: (qty: number) => void;
}

export const QuantityControl: FunctionalComponent<Props> = ({ value, max, onChange }) => {
  if (value === 0) {
    return (
      <button
        type="button"
        class="mw-add-btn"
        disabled={max <= 0}
        onClick={() => onChange(1)}
      >
        Add
      </button>
    );
  }

  return (
    <div class="mw-qty">
      <button type="button" class="mw-qty-btn mw-qty-btn--minus" onClick={() => onChange(Math.max(0, value - 1))}>
        −
      </button>
      <span class="mw-qty-value">{value}</span>
      <button type="button" class="mw-qty-btn mw-qty-btn--plus" disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))}>
        +
      </button>
    </div>
  );
};
